import { Typography } from '@mui/material';

/**
 * A component that renders text without wrapping it, meant to be used within
 * the data grid cells.
 */
export function NoWrapText(props: { text: string }) {
  return (
    <Typography component="span" variant="inherit" color="inherit" whiteSpace="nowrap">
      {props.text}
    </Typography>
  );
}
